import * as React from 'react';
import { useSelector } from 'react-redux';
import { offerSelector } from 'shared/selectors';
import { selectNewbuildingFromDeveloperUrl } from 'shared/selectors/newObject';

import { getJsonQuery } from './utils';
import { defaultTitleFromAddress } from './utils/defaultTitleFromAddress';
import { useSaveSearchContext } from '../../../packages/SaveSearchModal';

export function useSearchSetParams() {
  const { onOpen, setParams } = useSaveSearchContext();

  const offer = useSelector(offerSelector);
  const defaultTitle = React.useMemo(() => defaultTitleFromAddress(offer.geo.address), [offer.geo.address]);
  const jsonQuery = React.useMemo(() => getJsonQuery(offer), [offer]);
  const queryString = useSelector(selectNewbuildingFromDeveloperUrl);

  const handleClick = React.useCallback(() => {
    const additionalParams = {
      title: defaultTitle,
      modalTitle: 'Подписаться на локацию',
      submitButtonText: 'Подписаться',
      jsonQuery,
      analyticsParams: {
        pageType: 'Card',
        queryString,
        offerId: offer.id,
        isFromBanner: false,
      },
    };

    setParams(additionalParams);

    onOpen();
  }, [defaultTitle, jsonQuery, queryString, offer.id, onOpen, setParams]);

  return { handleClick, offerId: offer.id };
}
